import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { CartContextProvider } from "vino/context";
import { useCheckoutContext } from "vino/context";
import OrderProductTable from "./OrderProductTable";

const OrderSummary = () => {
	const { cartLineItems } = useCheckoutContext();

	return (
		<Paper className="w-full rounded-20 shadow">
			<div className="flex items-center justify-between p-20 pb-5">
				<Typography className="text-16 font-medium">Order Summary</Typography>
			</div>
			<CartContextProvider cartLineItems={cartLineItems}>
				<OrderProductTable />
			</CartContextProvider>
		</Paper>
	);
};

export default OrderSummary;
